<script setup lang="ts">
  const { $gtag } = useNuxtApp();
  const router = useRouter();
  const config = useRuntimeConfig();

  const baseUrl = `https://${config.public.project.domain}`;
  const canonicalUrl = `${baseUrl}${router.currentRoute.value.path.toString()}`;

  useHead({
    link: [{ rel: 'canonical', href: canonicalUrl }],
  });

  definePageMeta({
    middleware: ['track-page-visit-and-seen'],
  });

  onMounted(() => {
    $gtag?.logJob('job-details', 'offerdetail');
  });
</script>

<template>
  <PageJobDetails />
</template>
